import React from "react";
import MovieLayoutHoc from "../layout/Movie.layout";

const MoviePage = () => {
  return <div>MoviePage</div>;
};

export default MovieLayoutHoc(MoviePage);
